/* GJ Subscriber Bonus - injects a "free bags" callout into the Recharge cart
   drawer for pack products when a subscription is selected. Detection uses
   /cart.js (reliable); the Recharge drawer lives in an open shadow DOM, so we
   inject a scoped <style> + banner elements into that shadow root. */
(function () {
  if (window.__gjSubBonus) return;
  window.__gjSubBonus = true;

  var DRAWER_ID = 'recharge-storefront-experiences__cart-drawer';

  // base bag count -> bonus bags shipped on subscription
  function bonusFor(base) {
    if (base >= 10) return 3;
    if (base >= 5) return 2;
    if (base >= 3) return 1;
    return 0;
  }
  function baseFromItem(it) {
    var mix = (it.properties && it.properties['Flavor Mix']) || '';
    var m = mix.match(/[×x]\s*(\d+)/);
    if (m) return parseInt(m[1], 10);
    var byHandle = { '3-pack': 3, '5-pack': 5, 'the-jerk-pack': 10 };
    return byHandle[it.handle] || 0;
  }

  var STYLE = [
    '.gj-bonus-banner{',
    '  margin-top:12px;padding:11px 14px;border-radius:10px;',
    '  background:linear-gradient(100deg,#F25A07 0%,#F97316 45%,#16833a 130%);',
    '  color:#fff;font-weight:800;font-size:13px;line-height:1.3;letter-spacing:.01em;',
    '  display:flex;align-items:center;gap:8px;position:relative;overflow:hidden;',
    '  box-shadow:0 6px 18px rgba(242,90,7,.35);',
    '  animation:gjBonusPop .45s cubic-bezier(.16,1,.3,1);',
    '}',
    '.gj-bonus-banner__gift{font-size:18px;flex:0 0 auto;filter:drop-shadow(0 1px 2px rgba(0,0,0,.3));animation:gjBonusWiggle 2.2s ease-in-out infinite;}',
    '.gj-bonus-banner__big{font-family:inherit;}',
    '.gj-bonus-banner::after{',
    '  content:"";position:absolute;top:0;left:-60%;width:40%;height:100%;',
    '  background:linear-gradient(90deg,transparent,rgba(255,255,255,.45),transparent);',
    '  transform:skewX(-20deg);animation:gjBonusShine 3s ease-in-out infinite;',
    '}',
    '@keyframes gjBonusPop{0%{opacity:0;transform:translateY(8px) scale(.96);}100%{opacity:1;transform:none;}}',
    '@keyframes gjBonusShine{0%{left:-60%;}55%,100%{left:130%;}}',
    '@keyframes gjBonusWiggle{0%,88%,100%{transform:rotate(0);}92%{transform:rotate(-12deg);}96%{transform:rotate(12deg);}}',
    '@media (prefers-reduced-motion:reduce){.gj-bonus-banner,.gj-bonus-banner__gift,.gj-bonus-banner::after{animation:none;}}'
  ].join('\n');

  function ensureStyle(root) {
    if (root.getElementById && root.getElementById('gj-bonus-style')) return;
    if (root.querySelector && root.querySelector('#gj-bonus-style')) return;
    var s = document.createElement('style');
    s.id = 'gj-bonus-style';
    s.textContent = STYLE;
    root.appendChild(s);
  }

  // Find the line-item container in the shadow root that shows this Flavor Mix
  function findLineItem(root, mixText) {
    if (!mixText) return null;
    var els = root.querySelectorAll('*');
    var match = null;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length === 0 && el.textContent.indexOf(mixText) !== -1) { match = el; break; }
    }
    if (!match) return null;
    // climb until the ancestor also contains the subscription selector
    var node = match;
    for (var j = 0; j < 8 && node; j++) {
      node = node.parentElement;
      if (node && /Deliver every/i.test(node.textContent)) return node;
    }
    return match.parentElement;
  }

  /* ─── Strip fundraiser products from the Recharge "Goes great with" upsell ───
     Shopify's recommendation API pairs retail + fundraiser bags (shared
     collection), and Recharge's upsell pulls it raw. We remove any upsell
     slide for a fundraiser product so $15 bags never surface outside the
     fundraiser page. Match is by the fundraiser products' real titles
     (fetched, tag-filtered) plus a "(fundraiser)" name fallback. */
  var fundraiserTitles = null;
  (function loadFundraiserTitles() {
    fetch('/collections/fundraiser/products.json?limit=50', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var set = {};
        (d.products || []).forEach(function (p) {
          var tags = p.tags || [];
          if (!Array.isArray(tags)) tags = String(tags).split(',');
          var isFund = tags.some(function (t) { return String(t).trim().toLowerCase() === 'fundraiser'; });
          if (isFund) set[(p.title || '').trim().toLowerCase()] = true;
        });
        fundraiserTitles = set;
      })
      .catch(function () { fundraiserTitles = {}; });
  })();

  function isFundraiserText(txt) {
    var low = (txt || '').toLowerCase();
    if (low.indexOf('(fundraiser)') !== -1) return true;
    if (fundraiserTitles) {
      for (var title in fundraiserTitles) {
        if (title && low.indexOf(title) !== -1) return true;
      }
    }
    return false;
  }

  function stripFundraiserUpsells(root) {
    // Upsell items are horizontal carousel slides (basis-full); cart line
    // items are not, so this never touches something the shopper actually added.
    var slides = root.querySelectorAll('[class*="basis-full"]');
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      if (s.getAttribute('data-gj-stripped')) continue;
      if (isFundraiserText(s.textContent)) {
        s.setAttribute('data-gj-stripped', '1');
        s.style.display = 'none';
      }
    }
  }

  var busy = false;
  function update() {
    var host = document.getElementById(DRAWER_ID);
    var root = host && host.shadowRoot;
    if (!root) return;
    stripFundraiserUpsells(root);
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // clear old banners, then rebuild for qualifying items
        var old = root.querySelectorAll('.gj-bonus-banner');
        for (var k = 0; k < old.length; k++) old[k].remove();

        var qualifying = (cart.items || []).filter(function (it) {
          return it.selling_plan_allocation && bonusFor(baseFromItem(it)) > 0;
        });
        if (qualifying.length === 0) { busy = false; return; }

        ensureStyle(root);
        qualifying.forEach(function (it) {
          var base = baseFromItem(it);
          var bonus = bonusFor(base);
          var total = base + bonus;
          var mix = it.properties['Flavor Mix'];
          var li = findLineItem(root, mix);
          if (!li || li.querySelector('.gj-bonus-banner')) return;
          var b = document.createElement('div');
          b.className = 'gj-bonus-banner';
          b.innerHTML =
            '<span class="gj-bonus-banner__gift">🎁</span>' +
            '<span><span class="gj-bonus-banner__big">Subscriber bonus: +' + bonus +
            ' FREE bag' + (bonus === 1 ? '' : 's') + '</span> - ' + total + ' bags in every box 🔥</span>';
          li.appendChild(b);
        });
        busy = false;
      })
      .catch(function () { busy = false; });
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(update, 220); }

  // Attach a MutationObserver to the drawer shadow root once it exists
  var attached = false;
  function tryAttach() {
    var host = document.getElementById(DRAWER_ID);
    var root = host && host.shadowRoot;
    if (!root || attached) return;
    attached = true;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
    schedule();
  }

  var poll = setInterval(function () {
    tryAttach();
    if (attached) clearInterval(poll);
  }, 500);
  // keep a light heartbeat in case Recharge tears down/rebuilds the root
  setInterval(function () { attached = false; tryAttach(); }, 4000);
})();
